import { Marker } from 'react-map-gl';

import { useAppSelector } from 'src/app/store/hooks';
import { MapPin } from 'src/common/BambiMapView/MapPin';
import { TripEventRead } from 'src/common/external/bambi-api/bambiApi';

import { eventTypeColorMap } from './eventTypeColorMap';
import { getPinColors } from './getPinColors';
import { selectCurrentTripSummaryId } from './selectors/selectCurrentTripSummaryId';

export function TripEventMarker({
  tripEventMarker,
  onClick,
}: {
  tripEventMarker: TripEventRead;
  onClick?: () => void;
}) {
  const selectedTripEventId = useAppSelector(selectCurrentTripSummaryId);
  const isSelected = tripEventMarker.id === selectedTripEventId;

  const base = eventTypeColorMap[tripEventMarker.event_type];
  const pinColors = getPinColors(base);

  return (
    <Marker
      latitude={tripEventMarker.latitude ?? undefined}
      longitude={tripEventMarker.longitude ?? undefined}
      style={{ zIndex: isSelected ? 20 : 10 }}
      onClick={(e) => {
        e.originalEvent.stopPropagation();
        onClick?.();
      }}
    >
      <MapPin isSelected={isSelected} {...pinColors} />
    </Marker>
  );
}
